module.exports = __webpack_public_path__ + "img/30eb4ceb3e62c23bc90bf7b3a065922.97e57a80.png";